import { useModal } from "@/components/core/modals/use-modal.ts";
import CaseOccStatsModal from "@/features/overview/components/case-occ-stats-modal";

export default function CaseOccStats({ items }: { items: any }) {
	const modal = useModal();
	return (
		<div className="flex flex-col w-full h-auto p-4 gap-6">
			<div className="flex w-full h-[24px] mt-4 bg-slate-100 rounded-md gap-[1px]">
				{items.map(
					(item, index) =>
						item.count !== 0 && (
							<div
								key={index}
								className="relative flex w-full first:rounded-l-md last:rounded-r-md"
								style={{
									maxWidth: `${item.percentage}%`,
									backgroundColor: `${item.color}`,
								}}
							>
								<span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 whitespace-nowrap text-xs font-semibold text-foreground">
									{item.percentage}%
								</span>
							</div>
						),
				)}
			</div>

			<div className="grid grid-cols-2 w-full gap-y-4 gap-x-6 mt-auto">
				{items.map((item, index) => (
					<button
						key={index}
						onClick={() => {
							modal.openModal({
								allowClose: true,
								title: `${item.label} - Breakdown`,
								size: "md",
								showHeader: true,
								showFooter: false,
								component: <CaseOccStatsModal id={item.id} />,
							});
						}}
						type="button"
						className="group flex flex-col w-full gap-1 cursor-pointer"
					>
						<div className="inline-flex flex-row items-center gap-1">
							<span className="text-base font-semibold text-foreground-dark">
								{item.count}
							</span>
							<span className="text-base text-foreground/70">
								{item.code} {item.label}
							</span>
						</div>
						<div className="flex flex-row w-full h-[8px] bg-slate-200 group-hover:bg-slate-300/80 rounded-md overflow-hidden">
							<div
								className="flex w-full"
								style={{
									maxWidth: `${item.percentage}%`,
									backgroundColor: `${item.color}`,
								}}
							/>
						</div>
					</button>
				))}
			</div>
		</div>
	);
}
